module.exports = __webpack_public_path__ + "components/resort-webcams/static/icon--archive-a7ac6ce4425e69e8e5c397ac1d2bd630.svg";